import { render, staticRenderFns } from "./InspectionList.vue?vue&type=template&id=d67c4cc8&scoped=true"
import script from "./InspectionList.vue?vue&type=script&lang=js"
export * from "./InspectionList.vue?vue&type=script&lang=js"
import style0 from "./InspectionList.vue?vue&type=style&index=0&id=d67c4cc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67c4cc8",
  null
  
)

export default component.exports